/**
 * Expoxes endpoints which should be available under the window.writer scope
 */
class DWExposer {

    constructor() {
        this.endpoints = new Map()
        window.writer = {}
    }

    /**
     * Exposes a function or a class on the writer namespace `window.writer`
     *
     * @param {string} name - The key that will be on window.key
     * @param {object|class|function} value - Object, Class, Function which should be exposed
     */
    expose(name, value) {
        if(this.endpoints.get(name)) {
            throw new Error(`${name} already registered`)
        }

        this.endpoints.set(name, value)
        window.writer[name] = value
    }
}

export {DWExposer}
